module.exports = "<html>\n  <head>\n    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n    <title>New Seizeland</title>\n    <link href=\"https://fonts.googleapis.com/css?family=Montserrat:400,600,800,900\" rel=\"stylesheet\">\n  </head>\n\n  <body>\n    <div data-hook='main-outlet'></div>\n  </body>\n</html>\n";


//////////////////
// WEBPACK FOOTER
// ../index.html
// module id = 294
// module chunks = 0